<template>
  <div>
    <DefaultMenu>
        <template #title>
            Ley Karin
        </template>

        <b-button @click="openCreateModal">
          Denunciar <b-icon icon="inboxes" font-scale="1"></b-icon>
        </b-button>
        <b-button
                  v-permission="'karin-menu-notificaciones'"
                  @click="openNotificationModal"
                  class="ms-3"
                >
                  Notificaciones <b-icon icon="mailbox" font-scale="1"></b-icon>
                </b-button>
        

        <template #right>
            <b-button
                v-permission="'karin-reportes'"
                @click="modalShowReport = true"
                class="me-2"
            >
                <b-icon icon="file-pdf" font-scale="1"></b-icon>
            </b-button>
            <b-button
                v-permission="'karin-configuracion'"
                @click="modalShowSetting = true"
                title="Configuración"
                v-b-tooltip.hover.left
            >
                <b-icon icon="gear"/>
            </b-button>
        </template>
    </DefaultMenu>
    
    <BaseModal v-model="modalShowSetting" size="lg">
        <KarinSetting/>
    </BaseModal>

    <KarinFormModal></KarinFormModal>
       <KarinNotification></KarinNotification>
   <BaseModal v-model="modalShowReport" size="xl">
     <KarinReport />
   </BaseModal>
  </div>
</template>

<script>
import DefaultMenu from '@/components/shared/Default-menu.vue'
import KarinFormModal from '@/components/KarinLaw/KarinMenu/Karin-form-modal.vue';
import KarinNotification from "@/components/KarinLaw/KarinMenu/Karin-notification.vue";
import KarinSetting from './KarinMenu/Karin-setting.vue'
import KarinReport from './KarinMenu/Karin-report.vue';
import BaseModal from '@/components/shared/Base-modal.vue'
import { EventNames } from '@/plugins/enums';


export default {
  name: 'KarinMenu',

  components: {
    DefaultMenu,
    KarinFormModal,
    KarinNotification,
    KarinSetting,
    BaseModal,
    KarinReport,
  },

  data() {
    return {
      modalShowSetting: false,
      modalShowReport: false,
    }
  },

  methods: {
    openCreateModal() {
      this.$eventBus.$emit(EventNames.KarinOpenCreateModal);
    },

    openNotificationModal() {
      this.$eventBus.$emit(EventNames.KarinOpenNotificationModal);
    },
  }
}

</script>
